
import "../Styles/OurTeam.css"

const OurTeam = () => {
  return (
    <section className="gallery">
      <h2>Our Team</h2>
     <h3>Team members</h3>
    </section>
  );
};

export default OurTeam;
